<div class="ticket-box" *ngIf="ticket && IsPaid">
    <ion-item uppDataid="guestticket-thumb"
        lines="none"
        (click)="OnOpen()">
        <ion-icon slot="start" [name]="IconName"></ion-icon>
        <ion-label>
            {{ tr(TitleKey) }}<br/>
            <span class="small">{{ Elapsed }}</span>
        </ion-label>
        <ion-label class="price" slot="end" *ngIf="ticket.priceinfo as price">
            {{ price.int }},<span class="small">{{ price.dec }}</span>{{ tr('@currency') }}
        </ion-label>
    </ion-item>
</div>

<div class="ticket-box ticket-row-box" *ngIf="ticket && !IsPaid" [class.ready]="IsReady">
    <ion-item uppDataid="guestticket-thumb"
        lines="none"
        (click)="OnOpen()">
        <div class="ticket-row">
            <div class="ticket-row-top">
                <span class="order">#{{ ticket.orderno }}</span>
                <span class="price" *ngIf="ShowPrice && PriceParts as parts">
                    <ng-container *ngIf="IsNegative">-</ng-container>{{ parts.int }}<span class="decimal">,{{ parts.dec }}</span>{{ tr('@currency') }}
                </span>
            </div>
            <div class="ticket-row-action" *ngIf="IsReady">
                {{ tr(ActionKey) }}
            </div>
            <div class="ticket-row-action" *ngIf="IsPending && StatusKey">
                {{ tr(StatusKey) }}
                <br/><span class="small">{{ tr(ActionKey) }}</span>
            </div>
        </div>
    </ion-item>
</div>
